import type { IBrokerageDataWeb } from '@/app-package';
import axios from 'axios';

export const getBrokerageBillingProfile = async ({
  billingCustomerNumber,
}: {
  billingCustomerNumber: string;
}): Promise<IBrokerageDataWeb> => {
  try {
    const { data } = await axios.get<IBrokerageDataWeb>(
      `/billing/billing_profile/brokerage/${billingCustomerNumber}`,
    );
    return data;
  } catch (error: any) {
    if (error.response && error.response.status === 404) {
      return undefined;
    }
    throw error;
  }
};
